import { Paper, Skeleton, Box } from '@mui/material';

/**
 * Skeleton loader for project cards and similar card layouts
 *
 * @param {Object} props - Component props
 * @param {boolean} props.showStats - Whether to show stats skeleton
 * @param {number} props.height - Card height (default: auto)
 */
const CardSkeleton = ({ showStats = true, height = 'auto' }) => (
  <Paper
    elevation={2}
    sx={{
      p: 3,
      height,
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {/* Header */}
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <Skeleton variant="circular" width={48} height={48} sx={{ mr: 2 }} />
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width="80%" height={28} />
        <Skeleton variant="text" width="60%" height={20} />
      </Box>
    </Box>

    {/* Description */}
    <Skeleton variant="text" width="100%" />
    <Skeleton variant="text" width="90%" />

    {/* Stats section */}
    {showStats && (
      <Box sx={{ display: 'flex', gap: 2, mt: 'auto', pt: 2 }}>
        <Skeleton variant="rounded" width={60} height={24} />
        <Skeleton variant="rounded" width={60} height={24} />
        <Skeleton variant="rounded" width={60} height={24} />
      </Box>
    )}
  </Paper>
);

export default CardSkeleton;
